module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1a_Image3b.681ef81f.jpg";